import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="pulse-dot" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && roles.length && !roles.includes(user.role) && user.role !== "super_admin") {
    // Redirect to their proper home
    return <Navigate to={defaultRouteForRole(user.role)} replace />;
  }
  return children;
}

export function defaultRouteForRole(role) {
  if (role === "admin" || role === "super_admin" || role === "employee") return "/admin/dashboard";
  if (role === "operator") return "/operator/home";
  if (role === "customer") return "/customer/home";
  if (role === "business") return "/business";
  return "/login";
}
